import { Component, OnInit, Input } from '@angular/core';
import { TicketEvent } from '@app/shared/models/ticketHold.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-on-hold-card',
  templateUrl: './on-hold-card.component.html',
  styleUrls: ['./on-hold-card.component.scss'],
})
export class OnHoldCardComponent implements OnInit {

  @Input() ticketEvent: TicketEvent;

  isReasonVisible = false;

    constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  toggleReason(): void {
    this.isReasonVisible = !this.isReasonVisible;
  }

  get authorName(): string {
    const author = this.ticketEvent?.eventAuthor;

    if (!author) {
      return this.translate.instant('service.tickets.details.onEvent.systemAuthor');
    }

    return `${author.firstName} ${author.lastName}`;
  }

  get reasonText(): string {
    const reasonName = this.ticketEvent?.reason?.name;
    const description = this.ticketEvent?.description || '';

    return reasonName ? `${reasonName}<br>${description}` : description;
  }
}
